DoctorFinder.Views.Autocomplete.Result = class Result extends Sparkle.Spotlight.ItemsList.Item {
  constructor() {
    super(...arguments);
    this.handleChildToggle = this.handleChildToggle.bind(this);
    this.render = this.render.bind(this);
    this.buildText = this.buildText.bind(this);
    this.buildSubText = this.buildSubText.bind(this);
    this.buildFilterText = this.buildFilterText.bind(this);
    this.buildIcon = this.buildIcon.bind(this);
    this.toggleOpen = this.toggleOpen.bind(this);
    this.toggleClosed = this.toggleClosed.bind(this);
    this.isChild = this.isChild.bind(this);
    this.isParent = this.isParent.bind(this);
    this.triggerChildToggle = this.triggerChildToggle.bind(this);

    this.childIndicator = jQuery('<span class="child-indicator">');
    this.childToggle = jQuery('<i class="child-toggle">');

    // BEHAVIOUR

    this.el.on("click", ".child-toggle", this.handleChildToggle);
  }

  // EVENT HANDLERS

  handleChildToggle(event) {
    event.stopPropagation(); // Don't trigger an item click
    if (this.toggledOpen) {
      return this.toggleClosed();
    } else {
      return this.toggleOpen();
    }
  }

  // RENDERING

  render() {
    this.el.attr({ "data-type": this.data.type, "data-name": this.data.text });

    this.el.empty();
    this.el.append(this.buildIcon());

    if (this.isChild()) {
      this.el.hide(); // Hide children until they are shown by the parent
      this.el.addClass("child");
      this.el.append(this.childIndicator).attr({ "data-parent": this.data.parent, "data-depth": this.data.depth });
      let i = this.data.depth;
      while (--i) {
        this.el.append('<span class="child-indicator-spacing"></span>');
      }
    }

    const textContainer = jQuery("<span>", { class: "text-container" });
    if (this.data.text != null) {
      textContainer.append(this.buildText());
    }
    if (this.data.subtext != null) {
      textContainer.append(this.buildSubText());
    }
    if (this.data.showFilters != null) {
      textContainer.append(this.buildFilterText());
    }
    this.el.append(textContainer);

    if (this.isParent()) {
      this.el.addClass("parent").attr("aria-expanded", false).append(this.childToggle);
    }

    return this;
  }

  buildText() {
    const text = jQuery("<span>", { class: "text" }).text(this.data.text);
    if (this.data.parentName) {
      text.append(jQuery('<span class="parent_name"></span>').text(" (" + this.data.parentName + ")"));
    }

    return text;
  }

  buildSubText() {
    return jQuery("<span>", { class: "subtext" }).text(this.data.subtext);
  }

  buildFilterText() {
    return this.data.showFilters.map((filterText) => {
      const filterElement = jQuery("<span>", { class: "suggested-filter" });
      filterElement.append(filterText);
      return filterElement;
    });
  }

  buildIcon() {
    let iconClassVariant;
    if (this.data.parent) {
      iconClassVariant = "icon--none";
    }
    if (!iconClassVariant) {
      iconClassVariant = this.data.iconClass || "icon--default";
    }
    let iconClass = ["icon", iconClassVariant].join(" ");

    if (this.data.icon != null) {
      if (this.data.icon.includes("portrait-default")) {
        iconClass = "icon icon--portrait-default";
      }
      if (this.data.icon.includes("location-default")) {
        iconClass = "icon icon--location-default";
      }
    }

    const element = jQuery("<span>", { class: iconClass });
    if (this.data.icon != null) {
      element.css({ backgroundImage: `url(${this.data.icon})` });
    }
    return element;
  }

  // API

  toggleOpen() {
    if (this.isParent()) {
      this.toggledOpen = true;
      this.el.attr("aria-expanded", true);
      this.childToggle.addClass("open");
      return this.triggerChildToggle();
    }
  }

  toggleClosed() {
    if (this.isParent()) {
      this.toggledOpen = false;
      this.el.attr("aria-expanded", false);
      this.childToggle.removeClass("open");
      return this.triggerChildToggle();
    }
  }

  isChild() {
    return !!this.data.parent;
  }

  isParent() {
    return !!this.data.children;
  }

  // PRIVATE

  triggerChildToggle() {
    return this.el.trigger("childToggle", [this, this.el]);
  }
};
